import { QueryClient } from '@tanstack/react-query';

export type Query<T> = T & {
  queryClient: QueryClient;
};

export type Fetch<T> = T & {
  signal: AbortSignal;
};

export const queryKeysAsArray = (
  obj: Partial<Record<string, any>>,
) => {
  return Object.keys(obj)
    .reduce((accumulator, key) => [
      ...accumulator,
      `${key}: ${JSON.stringify(obj[key])}`.replace(/"/gm, ''),
    ], [] as string[]);
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes in milliseconds
      retry: 1,
    },
  },
});
